import { render, staticRenderFns } from "./AgendasSectionSearch.vue?vue&type=template&id=7d4c5352&scoped=true&"
import script from "./AgendasSectionSearch.vue?vue&type=script&lang=js&"
export * from "./AgendasSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4c5352",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
